import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { CheckList } from "src/app/core/services/business/model/check-list";
import { SubItem } from "src/app/core/services/business/model/sub-item";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { CheckListService } from "src/app/core/services/business/service/check-list.service";
import { SubItemService } from "src/app/core/services/business/service/sub-item.service";

@Component({
  selector: "app-form-check-list-modal",
  templateUrl: "./form-check-list-modal.component.html",
  styleUrls: ["./form-check-list-modal.component.scss"],
})
export class FormCheckListModalComponent implements OnInit {
  @Input() subItemId;

  form2: FormGroup;
  pressButton: Boolean = false;

  filefound: boolean = false;
  errorMessage: String = null;

  subItem: SubItem;
  checkLists: CheckList[];

  checkItem: CheckList = new CheckList();

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _checkListService: CheckListService,
    private _gestionFichierService: GestionFichierService,
    private _subItemService: SubItemService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      checkDoc: [true, Validators.compose([Validators.required])],
      commentaire: [null, Validators.compose([Validators.nullValidator])],
    });
  }

  ngOnInit() {
    this.getSubItemById(this.subItemId);
    this.getCheckListBySubitemid(this.subItemId);
  }

  getSubItemById(id) {
    this._subItemService.findById(id).subscribe(
      (data) => {
        this.subItem = data;
        this.form2.controls["checkDoc"].setValue(true);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCheckListBySubitemid(id) {
    this._checkListService.getCheckListBysubitemid(id).subscribe(
      (data) => {
        this.checkLists = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  check(): void {
    this.pressButton = true;
    this.checkItem.subItem = this.subItem;

    this.spinner.show();
    this._checkListService
      .add(this.checkItem)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.getCheckListBySubitemid(this.subItemId);
        },
        (error) => {
          console.log(error);
          this.errorMessage = error.error.message;
          this.spinner.hide();
        }
      );
  }

  downloadFile(subitemId: string, filename: string) {
    this._gestionFichierService.downloadFile(subitemId).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }
}
